import * as React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  TextField, IconButton, Box, Button, CircularProgress,
  Stack, TableContainer, Table, TableHead, TableRow, TableCell,
  TableBody, Paper, TablePagination
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useState, useEffect } from 'react';
import { Crypter } from '../Functions/Security/Crypter';
import SweetAlert from 'sweetalert2';
import Datas from "../Data/Data.json";
import axios from 'axios';
import { useAuthHeader } from '../Services/Auth/sessionAuth';
import DataType from '../Types/DataTablePiclist';
import ParamsPicklist from '../Types/ParamsPicklist';
import { Controller } from 'react-hook-form';
import { useRef } from 'react';


interface SearchModalProps {
     control: any;
  Titre: string;
  label: string;
  name: string;
  value?: string;
  libelleValue?: string;
  onChange: (name: string, value: string) => void;
  Parametre?: ParamsPicklist;
  notRequired?: boolean;
  width?: number | string;
  disabledCode?: boolean;
  disabledLibell?: boolean;
  notremove?: boolean;
}

const SearchModalMUI3 = (props: SearchModalProps) => {
  const [open, setOpen] = useState(false);
  const [libelle, setLibelle] = useState(props.libelleValue || '');
  const [code, setCode] = useState(props.value || '');
  const [data, setData] = useState<DataType[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [searchLoading, setSearchLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);


  const codeRef = useRef<HTMLInputElement>(null);
  const lastValidCode = useRef(code); // stocke la dernière valeur valide

  const authHeader = useAuthHeader();

  useEffect(() => {
    if (props.value) setCode(props.value);
    if (props.libelleValue) setLibelle(props.libelleValue);
  }, [props.value, props.libelleValue]);

  useEffect(() => {
  setCode(props.control._formValues[props.name] || "");
  setLibelle(props.control._formValues["lib_"+props.libelleValue] || "");
}, [props.control._formValues[props.name]]);


  const handleOpen = () => setOpen(true);
  
  const handleClose = () => {
    setSearchTerm('');
    setOpen(false);
  };

  const fetchData = async (init: string, choix: number) => {
    setLoading(true);
    const requestData = {
      CodeAgence: props.Parametre?.CodeAgence,
      Table: props.Parametre?.Table,
      Colonne1: props.Parametre?.Colonne1,
      Colonne2: props.Parametre?.Colonne2,
      Colagence: props.Parametre?.Colagence,
      Init: init,
      choix: choix,
      colfiltre: props.Parametre?.colfiltre,
      valfiltre: props.Parametre?.valfiltre,
    };

    try {
      const response = await axios.get(Datas.ApiUrl.AnySearch, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': authHeader(),
          'CypherSearch': Crypter.encrypt(JSON.stringify(requestData)),
        },
      });

      const decrypted = JSON.parse(Crypter.decrypt(response.data)).Value;
      if (decrypted.StatutCode === 200) {
        const result = decrypted.Result.Table;
        const mapped: DataType[] = result.map((item: any, index: number) => ({
          key: index,
          Code: item[Object.keys(item)[1]],
          Libelle: item[Object.keys(item)[0]],
        }));
        setData(mapped);

        if (mapped.length === 1) {
            handleSelect(mapped[0]);
        } 
        // else if (mapped.length === 0 && !props.notremove) resetFields();
      } else {
       
        // if (!props.notremove) resetFields();
        const mapped2: DataType[]=[]
         handleSelect(mapped2[0]);
      }
    } catch (error: any) {
      console.error(error);
      SweetAlert.fire({ title: 'Erreur', text: error.message, icon: 'error' });
    } finally {
      setLoading(false);
      setSearchLoading(false);
    }
  };

  const handleSelect = (item: DataType) => {
    setCode(item.Code);
    setLibelle(item.Libelle);
    props.onChange(props.name, item.Code);
    props.onChange('lib_' + props.name, item.Libelle);
    setOpen(false);
    // //🔹 Focus sur le TextField du code après la fermeture
    // setTimeout(() => {
    //     codeRef.current?.focus();
    //     codeRef.current?.select(); // optionnel : sélectionne le texte
    // }, 100);
  };

  const resetFields = () => {
    setCode('');
    setLibelle('');
    props.onChange(props.name, '');
    props.onChange('lib_' + props.name, '');
  };

  const handleBlur = async () => {
  if (!code) return; // pas de code saisi

  try {
    const response = await axios.get(Datas.ApiUrl.AnySearch, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authHeader(),
        'CypherSearch': Crypter.encrypt(JSON.stringify({
          CodeAgence: props.Parametre?.CodeAgence,
          Table: props.Parametre?.Table,
          Colonne1: props.Parametre?.Colonne1,
          Colonne2: props.Parametre?.Colonne2,
          Init: code,
          choix: 22
        }))
      }
    });

    const decrypted = JSON.parse(Crypter.decrypt(response.data)).Value;
    const result = decrypted.Result.Table;

    if (result.length === 1) {
      // la valeur est valide
      handleSelect({
        key: 0,
        Code: result[0][Object.keys(result[0])[1]],
        Libelle: result[0][Object.keys(result[0])[0]],
      });
      lastValidCode.current = code; // mise à jour de la dernière valeur valide
    } else {
      // valeur non valide → vider le champ
      setCode('');
      setLibelle('');
      props.onChange(props.name, '');
      props.onChange('lib_' + props.name, '');
    }
  } catch (error) {
    console.error(error);
    SweetAlert.fire({ title: 'Erreur', text: "Aucune element trouvé", icon: 'error' });
    // ici aussi tu peux vider le champ si tu veux
    setCode('');
    setLibelle('');
  }
};
  return (
    <Box display="flex" flexDirection="column" sx={{ mb: 1 }}>
      <Box display="flex" gap={1} width="100%">
      <Controller
            control={props.control}
            name={props.name}
            render={({ field: { value, onChange } }) => (
                    <Box display="flex" gap={1} width="100%">

                    <TextField
                            label={props.label}
                            value={code}
                            onChange={(e) => {
                                
                                const v = e.target.value;
                                setCode(v);
                                onChange(v);          // met RHF à jour
                               
                            }}
                           // onBlur={() => fetchData(code, 22)}
                           onBlur={handleBlur}
                            disabled={props.disabledCode}
                            size="small"
                            variant="outlined"
                            inputRef={codeRef} // <-- Attacher la ref ici
                            InputProps={{
                                endAdornment: (
                                <IconButton
                                    onClick={handleOpen}
                                    disabled={props.disabledCode}
                                    sx={{ color: '#2196f3' }}
                                >
                                    <SearchIcon />
                                </IconButton>
                                ),
                            }}
                            sx={{
                                width: props.width || 150,
                                borderRadius: 10,
                                '& .MuiInputLabel-root': {
                                fontWeight: 'bold',
                                fontSize: '16px',
                                },
                            }}
                        />


                        {/* Champ Libellé */}
                        <TextField
                        fullWidth
                        // label="Libellé"
                        variant="outlined"
                        value={libelle}
                        onChange={(e) => {
                            const upperValue = e.target.value.toUpperCase();
                            setLibelle(upperValue);
                            props.onChange('lib_' + props.name, upperValue);
                        }}
                        disabled={props.disabledLibell}
                        size="small"
                        // InputLabelProps={{ shrink: true }}
                        InputProps={{
                            endAdornment: searchLoading ? <CircularProgress size={18} /> : null,
                        }}
                        sx={{
                            borderRadius: 10,
                            '& .MuiInputLabel-root': {
                            fontWeight: 'bold',
                            fontSize: '16px',
                            },
                        }}
                        />

                    </Box>
                  )}
        />

      </Box>

      {/* Modal de recherche */}
      <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
        <DialogTitle>{props.Titre}</DialogTitle>
        <DialogContent dividers>
          <Stack spacing={2}>
            <Box display="flex" gap={2}>
             <TextField
                    autoFocus
                    label="Recherche"
                    fullWidth
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    size="small"
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') fetchData(searchTerm, props.Parametre?.Choix || 22);
                    }}
                    InputProps={{
                        endAdornment: (
                        <IconButton
                            color="primary"
                            onClick={() => fetchData(searchTerm, props.Parametre?.Choix || 22)}
                            aria-label="Rechercher"
                            size="small"
                        >
                            <SearchIcon />
                        </IconButton>
                        ),
                    }}
                    />

            </Box>
          </Stack>

          <TableContainer component={Paper} sx={{ mt: 2, maxHeight: 300 }}>
            <Table stickyHeader size="small">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: '#fff', py: 1.5, backgroundColor: '#107C41' }}>
                    Code
                  </TableCell>
                  <TableCell sx={{ color: '#fff', py: 1.5, backgroundColor: '#107C41' }}>
                    Libellé
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {data
                  .filter((row) =>
                    `${row.Code}${row.Libelle}`.toLowerCase().includes(searchTerm.toLowerCase())
                  )
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => (
                    <TableRow
                      key={row.key}
                      hover
                      onClick={() => handleSelect(row)}
                      sx={{
                        cursor: 'pointer',
                        backgroundColor: index % 2 === 0 ? '#f5f5f5' : '#ffffff',
                        '&:hover': {
                          background: 'linear-gradient(90deg, #eaf3ff 0%, #dceeff 100%)',
                        },
                      }}
                    >
                      <TableCell>{row.Code}</TableCell>
                      <TableCell>{row.Libelle}</TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={data.length}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(0);
            }}
            rowsPerPageOptions={[5, 10, 25, { label: 'Tout afficher', value: data.length }]}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Fermer</Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default SearchModalMUI3;
